import { useEffect } from 'react';
import { FieldValues, UseFormSetError } from 'react-hook-form';

import { FieldServerError } from '@app/common/types/validation';
import { isNotEmptyArray } from '..';

/**
 * Applies all server field errors to the form with auto field focusing.
 */
export const useServerFieldsErrors = (
  setError: UseFormSetError<FieldValues>,
  fieldErrors: Array<FieldServerError> | null,
): void => {
  useEffect(() => {
    if (isNotEmptyArray(fieldErrors)) {
      // show all field server errors
      fieldErrors.forEach((fieldError) => {
        setError(
          fieldError.fieldId,
          // eslint-disable-next-line i18next/no-literal-string
          { message: fieldError.message, type: 'server' },
          { shouldFocus: true },
        );
      });
    }
  }, [setError, fieldErrors]);
};
